<div class="accordion" id="accordionExample" style="margin-top: -25px;">

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Werking van het scherm 'Verdeling'
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij de aanwezigheid van fiscaal partnerschap en verdeelposten kom je het scherm 'Verdeling' tegen. Het
                programma berekent automatisch een voordelige verdeling. Dat houdt in dat gezocht wordt naar een verdeling
                die leidt tot de laagste gezamenlijke belastingbedragen. Klik op de button 'Pas de voorgestelde
                verdeling toe' en de gegevens worden gezet in de kolom voor de toe te passen verdeling.
                <div class="space10"></div>
                Je kunt de automatische verdeling aanpassen door in de kolom 'Aangever' bedragen te wijzigen. Zodra je
                dat doet wordt de nieuwe belasting berekend. Het verschil wordt getoond. En je kunt daarna altijd nog
                kiezen voor de optimale verdeling.
                <div class="space10"></div>
                <b>Belangrijk</b><br/>
                De verdeling zoals weergegeven in de kolommen <b>'Toe te passen verdeling'</b> worden in de aangifte
                gezet.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse" aria-expanded="false" aria-controls="collapse">
                Gezamenlijke inkomsten en aftrekbare uitgaven verdelen
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Fiscaal partnerschap</b><br/>
                Het fiscaal partnerschap betekent dat je samen aangifte kunt doen en inkomsten en aftrekposten verdelen.
                De manier waarop je deze verdeelt, kan van invloed zijn op de belasting en premie die je betaalt of
                terugkrijgt. Iedere verdeling mag, als het totaal maar 100% is.
                <div class="space10"></div>

                <b>Kies je ervoor om het hele jaar fiscale partners te zijn of een deel ervan?</b><br/>
                Heb je maar een deel van het jaar een fiscale partner? Dan kun je bij je aangifte ervoor kiezen om het
                hele jaar als fiscale partners te worden beschouwd. Heb je binnen 1 jaar meerdere fiscale partners na
                elkaar? Dan kun je met 1 van deze personen ervoor kiezen om het hele jaar als fiscale partners te worden
                beschouwd.
                <div class="space10"></div>

                <b>Kunnen meerdere personen na elkaar uw fiscale partner zijn?</b><br/>
                Ja, dat kan. Bijvoorbeeld omdat je tijdens het jaar gescheiden bent en met iemand anders bent gaan
                samenwonen. In dat geval is elke persoon met wie je aan de voorwaarden voldoet voor een deel van het
                jaar je fiscale partner. Je kunt met 1 van deze personen ervoor kiezen om het hele jaar als fiscale
                partners te worden beschouwd.

                <div class="space10"></div>
                <b>Kunnen meerdere personen tegelijkertijd je fiscale partner zijn?</b>
                Nee, je kunt wel met meerdere personen tegelijkertijd aan de voorwaarden voor fiscaal partnerschap
                voldoen, maar je mag maar 1 fiscale partner hebben. Het is dan belangrijk te kijken naar de situatie met
                wie van hen je voldoet aan welke specifieke voorwaarde ( zie hieronder). De persoon met wie je als 1e
                voldoet aan een specifieke voorwaarde is uw fiscale partner.
                <div class="space10"></div>

                <b>Voorwaarden fiscale partner</b><br>
                Wie je fiscale partner is, hangt af van uw situatie. We onderscheiden 2 situaties.
                <div class="space10"></div>

                <b>1. Je bent getrouwd of hebt een geregistreerd partnerschap</b><br/>
                Dan ben je fiscale partners vanaf het moment dat je trouwt of een geregistreerd partnerschap aangaat.
                Woonde je in dat jaar vóór die datum al samen? Dan ben je fiscale partners vanaf het moment dat je
                binnen dat jaar samen op hetzelfde adres stond ingeschreven bij de gemeente.
                <div class="space10"></div>

                <b>2. Je bent niet getrouwd en hebt geen geregistreerd partnerschap. Maar er staat wel iemand
                    ingeschreven op je adres</b><br/>
                Je bent fiscale partners als je voldoet aan 1 van de volgende voorwaarden:
                <li class="list">je bent allebei meerderjarig en hebt samen een notarieel samenlevingscontract
                    afgesloten.
                </li>
                <li class="list">je hebt samen een kind.</li>
                <li class="list">1 van beiden heeft een kind van de ander erkend.</li>
                <li class="list">je bent bij een pensioenfonds aangemeld als pensioenpartners.</li>
                <li class="list">je bent samen eigenaar van een eigen woning waarin je allebei woont.</li>
                <li class="list">je bent allebei meerderjarig en op je adres staat ook een minderjarig kind van 1 van je
                    beiden ingeschreven (samengesteld gezin).<br/>
                    Verhuur je een deel van je woning aan degene met wie
                    je op hetzelfde adres staat ingeschreven? En wil je met die persoon geen fiscale partners zijn? Dan
                    kun je een verzoek doen bij je belastingkantoor om niet als fiscaal partner te worden aangemerkt. Je
                    moet dan wel een schriftelijke huurovereenkomst hebben en er moet sprake zijn van verhuur op
                    zakelijke gronden. Huur je ieder apart een eigen deel van de woning van een derde? En wil je met de
                    andere huurder geen fiscale partners zijn? Dan kun je ook een verzoek doen bij je belastingkantoor.
                </li>
                <li class="list">je bent meerderjarig. Ook woon je met een minderjarig kind in een opvangwoning of een
                    huis voor beschermd wonen. Je kreeg deze door de Wet maatschappelijke ondersteuning 2015. Je bewoont
                    die woning samen met een meerderjarige die volgens de gemeente ook op dat adres staat ingeschreven.
                    Wil je met die persoon geen fiscale partners zijn? Dan moet je de Belastingdienst een afschrift
                    kunnen tonen van de beschikking waaruit blijkt dat deze woning aan je beiden afzonderlijk is
                    toegekend.
                </li>
                <li class="list">je was het jaar ervoor al fiscale partners.</li>
                <li class="list">je woont samen met je kind of met je vader of moeder. Je voldoet ook aan 1 van de
                    bovenstaande voorwaarden en je bent allebei 27 jaar of ouder.
                </li>
                <li class="list">je hebt een stiefkind en voldoet aan 1 van de voorwaarden voor fiscaal partnerschap met
                    uw stiefkind. Dan ben je fiscale partners vanaf het moment dat je stiefkind 18 jaar is.
                    Wil je geen fiscale partners zijn met je stiefkind? Dan kun je daarvoor kiezen tot je beiden aan het
                    begin van het kalenderjaar 27 jaar of ouder bent. Stuur hiervoor een gezamenlijk verzoek naar je
                    belastingkantoor.
                    <div class="space10"></div>

                    Heb je geen fiscale partner(s)? Dan ben je ook geen toeslagpartner(s). Heb je ons verzocht om geen
                    fiscale partners meer te zijn voor de inkomstenbelasting? Dan bent je ook
                    geen toeslagpartners meer.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Welke inkomsten en aftrekposten mag je verdelen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor de verdeling tussen fiscaal partners komen de volgende inkomsten en aftrekposten in aanmerking:
                <li class="list">het saldo van de inkomsten en aftrekposten van de eigen woning</li>
                <li class="list">aftrek vanwege geen of een kleine eigenwoningschuld</li>
                <li class="list">voordeel uit aanmerkelijk belang</li>
                <li class="list">de gezamenlijke grondslag sparen en beleggen (box 3)</li>
                <li class="list">betaalde partneralimentatie en andere onderhoudsverplichtingen</li>
                <li class="list">uitgaven voor specifieke zorgkosten</li>
                <li class="list">uitgaven voor tijdelijk verblijf thuis van ernstig gehandicapte kinderen, broers of
                    zussen
                </li>
                <li class="list">giften</li>
                <li class="list">restant persoonsgebonden aftrek over vorige jaren</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Welke inkomsten en aftrekposten mag je niet verdelen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor de verdeling tussen fiscaal partners komen de volgende inkomsten en aftrekposten NIET in
                aanmerking:
                <li class="list">belastbare winst uit onderneming</li>
                <li class="list">loon, uitkering of pensioen</li>
                <li class="list">reisaftrek openbaar vervoer</li>
                <li class="list">inkomsten uit overig werk, bijvoorbeeld als postbezorger, gastouder, artiest of
                    beroepssporter
                </li>
                <li class="list">inkomsten uit beschikbaar gestelde vermogensbestanddelen</li>
                <li class="list">ontvangen alimentatie en andere periodieke uitkeringen</li>
                <li class="list">uitgaven voor inkomensvoorzieningen, zoals premies voor lijfrenten</li>
                <li class="list">negatieve uitgaven voor inkomensvoorzieningen</li>
                <li class="list">terugbetaalde studiebeurs (scholingsuitgaven)</li>
                <li class="list">negatieve persoonsgebonden aftrek</li>
                <li class="list">de gezamenlijke grondslag sparen en beleggen in het jaar waarin je bent geëmigreerd of
                    geïmmigreerd. Je kunt de grondslag sparen en beleggen alleen tussen jou en je partner verdelen als
                    je het hele jaar fiscale partners kunt zijn. Voor de periode dat je niet in Nederland woont, gelden
                    aanvullende voorwaarden.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Tot wanneer kun je de verdeling wijzigen?
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Totdat je aanslag en die van je partner onherroepelijk vaststaat. Als je geen bezwaar maakt, is dat 6
                weken na de datum van de aanslag. Tot die tijd kun je in je aangifte de verdeling wijzigen en deze
                opnieuw versturen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                De optimale verdeling
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                In het aangifteprogramma zit een automatische verdeling. Deze zoekt automatisch de optimale
                verdeling van de gezamenlijke posten. Met de 'optimale verdeling' bedoelen we in eerste instantie de
                verdeling waarbij de gezamenlijke belastingdruk zo laag mogelijk is. Zo houdt de tool ook rekening met
                de verschillende tarieven, de hoogtes van het inkomen, de heffingskortingen en de aanslaggrens.
                <div class="space10"></div>

                <b>Is 'de optimale verdeling' ook de beste verdeling?</b><br/>
                In verreweg de meeste situaties zal dat inderdaad het geval zijn. Maar er zijn situaties denkbaar dat
                dat het geval is. Bijvoorbeeld als er bij een van de partners sprake is een negatief inkomen en
                'optimale verdeling' van gezamenlijke posten niet of nauwelijks wat oplevert. Dan kun je er voor kiezen
                de aftrekposten toe te rekenen aan degene met een negatief inkomen, omdat het via verliesverrekening een
                groter voordeel oplevert.<br/>
                Beoordeel dus altijd zelf of de door het systeem voorgestelde 'optimale verdeling' wel de beste
                verdeling is. Zie ook het onderdeel hierna: 'De verdeling en toeslagen in geval van toeslagenpartner
                gedurende het jaar '.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                De verdeling en toeslagen in geval van toeslagenpartner gedurende het jaar
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een voor de inkomstenbelasting optimale verdeling hoeft dat niet te zijn voor de de toeslagen.
                <div class="space10"></div>

                Is er in {{ this.year }} sprake van het begin of het einde van een toeslagpartnerschap? En heeft
                minstens 1 van jullie op basis van het inkomen recht op een toeslag? Let dan op! In tegenstelling tot de
                inkomstenbelasting ga je voor de toeslagen uit van ieders individuele vermogen. Het gaat dan daarbij
                niet om wat van wie is, maar om wie wat krijgt toegedeeld in de belastingaangifte. Dat kan dus heel goed
                het vermogen van de ander zijn.
                <div class="space10"></div>

                <b>Verlies van een toeslag</b><br/>
                Je kunt dus ook een toeslag verliezen als je door een onhandige/ongunstige verdeling van vermogen in de
                aangifte inkomstenbelasting boven de vermogensgrens voor de toeslagen komt. Maar met een slimme
                verdeling haal je soms juist wel een toeslag binnen.
                <div class="space10"></div>

                <b>Ga schuiven en stel zo het recht op een toeslag veilig</b><br/>
                In de inkomstenbelasting kies je eigenlijk altijd wel voor het hele jaar partnerschap. Je mag dan jullie
                gezamenlijke vermogen verdelen zoals de partners zelf willen. Verdeel voor de toeslagen het vermogen dan
                zo, dat de ontvanger van de toeslag onder de vermogensgrenzen blijft. Zo zorg je dat diegene niet te
                veel vermogen heeft om de toeslag te krijgen.
                <div class="space10"></div>

                Dit kan in het jaar waarin het fiscale partnerschap begint of eindigt. Beide partners moeten deze
                verdeling wel accepteren. Als partners uit elkaar gaan kan het natuurlijk zijn ze niet altijd meer
                bereid de ander hierbij te helpen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Verdeling rendementsgrondslag voor inkomensafhankelijke regelingen
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bepaalde inkomensafhankelijke regelingen zoals bijv. de huurtoeslag, zijn afhankelijk van het vermogen
                op 1 januari. Komt het vermogen boven een bepaalde grens, dan is er mogelijk geen recht op de regeling.
                <div class="space10"></div>

                <b>Voorbeeld</b><br/>
                In 2024 kun je huurtoeslag krijgen als je vermogen op 1 januari 2024 niet hoger was dan € 36.952. Heb je
                een toeslagpartner? In dat geval mag het vermogen van je samen op 1 januari 2024 maximaal € 73.904 zijn.
                <br/>
                Staat de toeslagpartner niet op jouw adres ingeschreven en is dit je echtgenoot of geregistreerde partner?
                Dan telt zijn vermogen voor de huurtoeslag niet mee, maar voor de andere toeslagen wél.<br/>
                Ook medebewoners mogen niet meer dan € 36.952 aan vermogen hebben.
            </div>
        </div>
    </div>


</div>



